import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { api, MenuAvailability } from '@restaurant/api';
import { useCallback, useMemo } from 'react';

const QUERY_KEY = ['fetchMenuAvailability'];

const queryOptions = {
  queryKey: QUERY_KEY,
  queryFn: api.fetchMenuAvailabilities,
};

export const useMenuAvailability = () => {
  const {
    data: { menuAvailabilities },
  } = useSuspenseQuery(queryOptions);

  return menuAvailabilities;
};

const selector = (
  data: Awaited<ReturnType<typeof api.fetchMenuAvailabilities>>
) => {
  return (
    data.menuAvailabilities?.reduce<
      Record<string, MenuAvailability | undefined>
    >((acc, cur) => {
      acc[cur.menuId] = cur;
      return acc;
    }, {}) ?? {}
  );
};

export const useMenuAvailabilityMap = () => {
  const { data } = useSuspenseQuery({
    ...queryOptions,
    select: selector,
  });

  return data;
};

export const useRefreshMenuAvailability = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    return queryClient.invalidateQueries({
      queryKey: QUERY_KEY,
    });
  }, [queryClient]);
};
